
import { Button } from '@/components/ui/button';
import { Hand } from 'lucide-react';

const HeaderV3 = () => {
  const scrollToWaitlist = () => {
    const waitlistSection = document.querySelector('#waitlist-section');
    if (waitlistSection) {
      waitlistSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="relative z-50 bg-transparent">
      <div className="container max-w-6xl mx-auto px-4 py-6">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4">
            <div className="w-16 h-16 bg-yellow-400 rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-300">
              <Hand className="w-10 h-10 text-purple-700" />
            </div>
            <span className="text-white font-black text-3xl tracking-tight">Show Up!</span>
          </div>
          
          <div className="flex items-center gap-4">
            <a 
              href="/" 
              className="text-white/80 hover:text-white transition-colors font-medium hidden sm:block"
            >
              Try App
            </a>
            <Button
              onClick={scrollToWaitlist}
              className="bg-yellow-400 text-purple-700 hover:bg-yellow-300 rounded-xl px-6 py-2 font-black transition-all duration-300 hover:scale-105"
            >
              Start Your First PACT
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default HeaderV3;
